import script from "./IconClock.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconClock.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__